import { html, css, LitElement } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { clone, cloneDeep } from 'lodash-es';
import { library, dom } from "@fortawesome/fontawesome-svg-core";   
 
import './badge.js';
import { t, Localized } from './i18n.js';

export class IntrivityTeamsSelector extends Localized(LitElement) {

    static get styles() {
        return css`
            .teams {
                padding: 5px;
                width: 100%;
                color: white;
                /* #71797E gave 4.43:1 with white — just under AA. */
                background-color: #6a7176;
            }
            .section-header {
                margin: 0 0 5px 0;
                width: 100%;
                box-sizing: border-box;
                color: black;
                font-size: 1.5em;
                font-weight: normal;
                padding: 15px 10px 10px 30px;
                background-color: gray;
            }
        `;
    }
    
    static get properties() {
        return {
            group_reports: { type: Array },
            expanded: { type: Boolean }
        };
    }

    constructor() {
        super(); 
    }

    render() {
        return html`
        
            <h2 class="section-header">${t('teams.myTeams')}</h2>
        `
    } 
 
}
if (!customElements.get('intrivity-teams-selector')) customElements.define('intrivity-teams-selector', IntrivityTeamsSelector);
